module.exports = __webpack_public_path__ + "img/icn_web_call.28b98b21.svg";